var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "realname-auth-form" },
    [
      _c(
        "el-form",
        { attrs: { model: _vm.itemInfo, "label-width": "120px" } },
        [
          _c(
            "el-form-item",
            { attrs: { label: "提示内容" } },
            [
              _c("el-input", {
                attrs: {
                  clearable: "",
                  type: "textarea",
                  rows: 4,
                  resize: "none",
                  placeholder: "请输入提示内容",
                },
                on: { change: _vm.updateItem },
                model: {
                  value: _vm.itemInfo.promptContent,
                  callback: function ($$v) {
                    _vm.$set(_vm.itemInfo, "promptContent", $$v)
                  },
                  expression: "itemInfo.promptContent",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }